import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TVIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TVIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.64845 20.0045C8.34376 20.0045 8.12989 19.7574 8.0752 19.5133C8.01465 19.235 8.14356 18.9772 8.40625 18.8551L10.042 17.9869H4.90332C3.58887 17.986 2.51953 16.9157 2.51855 15.6002V7.10217C2.51953 5.78772 3.58886 4.7174 4.90332 4.71545H19.9961C21.3105 4.7174 22.3809 5.78772 22.3818 7.10217V15.6012C22.3799 16.9156 21.3096 17.986 19.9961 17.9869H14.8574L16.498 18.858C16.7773 18.9938 16.8496 19.2887 16.7969 19.5201C16.7432 19.7535 16.5479 19.9899 16.2344 19.9899C16.1172 19.9889 16.0195 19.9655 15.9326 19.9196L12.4512 18.068C12.3203 18.1383 11.9355 18.3424 11.0547 18.8073C10.1299 19.2955 8.97852 19.9039 8.91992 19.9391C8.82129 19.985 8.73438 20.0045 8.64845 20.0045ZM4.90332 5.91564C4.25 5.91662 3.71777 6.44884 3.71777 7.10216V15.6002C3.71875 16.2535 4.25097 16.7858 4.90332 16.7867H19.9961C20.6494 16.7858 21.1816 16.2535 21.1816 15.6002V7.10217C21.1807 6.44885 20.6484 5.91662 19.9961 5.91565L4.90332 5.91564Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.9959 4.81506H4.90325C3.64075 4.81706 2.61834 5.84013 2.61768 7.10263V15.6007C2.61835 16.8632 3.64075 17.8862 4.90325 17.8876H10.4434L8.44799 18.946C7.85642 19.2208 8.26792 20.1258 8.86549 19.855C8.8995 19.829 12.4082 17.9816 12.4496 17.9543L15.9796 19.8304C16.0517 19.869 16.1317 19.889 16.2137 19.889C16.7239 19.9097 16.9107 19.1694 16.4512 18.946L14.4557 17.8876H19.9959C21.2577 17.8863 22.2801 16.8632 22.2815 15.6013V7.10264C22.2808 5.84014 21.2584 4.81706 19.9959 4.81506ZM21.2811 15.6C21.2811 16.3103 20.7062 16.8858 19.9959 16.8865H4.90325C4.19364 16.8858 3.61874 16.3103 3.61807 15.6007V7.10264C3.61807 6.39236 4.19296 5.8168 4.90325 5.81613H19.9959C20.7055 5.8168 21.2804 6.39236 21.2811 7.10197L21.2811 15.6Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.68554 13.7604C9.35449 13.7604 9.08594 13.4918 9.08594 13.1608V10.1412H7.80273C7.47168 10.1412 7.20312 9.87269 7.20312 9.54163C7.20312 9.21057 7.47167 8.94202 7.80273 8.94202H11.5684C11.9561 8.943 12.1592 9.24475 12.1592 9.54163C12.1592 9.83851 11.9561 10.1403 11.5684 10.1412H10.2852V13.1608C10.2852 13.4918 10.0166 13.7604 9.68554 13.7604Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.5679 9.04163H7.80245C7.52634 9.04163 7.30225 9.26572 7.30225 9.54183C7.30225 9.81794 7.52634 10.042 7.80245 10.042H9.185V13.1606C9.185 13.4367 9.40909 13.6608 9.6852 13.6608C9.96131 13.6608 10.1854 13.4367 10.1854 13.1606V10.042H11.5679C12.2222 10.0394 12.2222 9.04497 11.5679 9.04163Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.3328 13.7535C15.0955 13.7535 14.8885 13.6266 14.7918 13.4225L13.0272 9.80529C12.9334 9.61095 12.9402 9.41076 13.0457 9.24084C13.16 9.06018 13.3729 8.94299 13.5906 8.94299C13.8143 8.94299 14.0027 9.06408 14.1072 9.27697L15.3318 11.7897L16.5574 9.27795C16.657 9.07385 16.8689 8.94104 17.0965 8.94104C17.1883 8.94104 17.2771 8.96155 17.3602 9.00256C17.5037 9.07287 17.6121 9.19494 17.6648 9.34631C17.7166 9.49865 17.7068 9.66174 17.6365 9.80529L15.8719 13.4235C15.7762 13.6266 15.5692 13.7535 15.3328 13.7535Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.3161 9.09249C17.068 8.97111 16.7685 9.07448 16.6472 9.32258L15.332 12.0183L14.0174 9.32124C13.7273 8.73434 12.831 9.17051 13.1164 9.76141L14.8825 13.3802C15.0545 13.7437 15.6087 13.7463 15.7815 13.3802L17.5462 9.76141C17.6676 9.51331 17.5642 9.21387 17.3161 9.09249Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TVIcon;
